import { render, staticRenderFns } from "./loadingButtom.vue?vue&type=template&id=62c58db8&scoped=true"
import script from "./loadingButtom.vue?vue&type=script&lang=js"
export * from "./loadingButtom.vue?vue&type=script&lang=js"
import style0 from "./loadingButtom.vue?vue&type=style&index=0&id=62c58db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c58db8",
  null
  
)

export default component.exports